// Email validation
export const emailValidation = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Phone number validation
export const phoneValidation = (phone: string): boolean => {
  const phoneRegex = /^[0-9]{10}$/;
  return phoneRegex.test(phone.replace(/\s/g, ''));
};

// Password validation (min 8 chars, at least one letter and one number)
export const passwordValidation = (password: string): boolean => {
  const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}$/;
  return passwordRegex.test(password);
};

// Name validation (only letters and spaces)
export const nameValidation = (name: string): boolean => {
  const nameRegex = /^[a-zA-Z\s]{2,}$/;
  return nameRegex.test(name);
};

// OTP validation (6 digits)
export const otpValidation = (otp: string): boolean => {
  const otpRegex = /^[0-9]{6}$/;
  return otpRegex.test(otp);
};

// PIN validation (4 digits)
export const pinValidation = (pin: string): boolean => {
  const pinRegex = /^[0-9]{4}$/;
  return pinRegex.test(pin);
};

// SEBI registration number validation
export const sebiRegValidation = (regNumber: string): boolean => {
  // Basic validation - can be enhanced based on actual format
  return regNumber.length >= 5 && regNumber.length <= 20;
};

// Amount validation (positive number with up to 2 decimal places)
export const amountValidation = (amount: string): boolean => {
  const amountRegex = /^\d+(\.\d{1,2})?$/;
  return amountRegex.test(amount) && parseFloat(amount) > 0;
};

// Bank account number validation
export const bankAccountValidation = (accountNumber: string): boolean => {
  const accountRegex = /^[0-9]{9,18}$/;
  return accountRegex.test(accountNumber);
};

// IFSC code validation
export const ifscValidation = (ifsc: string): boolean => {
  const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  return ifscRegex.test(ifsc);
};

// PAN card validation
export const panValidation = (pan: string): boolean => {
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  return panRegex.test(pan);
};

// Aadhaar validation
export const aadhaarValidation = (aadhaar: string): boolean => {
  const aadhaarRegex = /^[0-9]{12}$/;
  return aadhaarRegex.test(aadhaar.replace(/\s/g, ''));
};
